var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.2,
    height: 31.05,
    viewBox: "0 0 44.2 31.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9E021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "group",
    d: "M3.4,40a1.454,1.454,0,0,1-1.5-1.5V35.3a5.824,5.824,0,0,1,.9-3.175A5.477,5.477,0,0,1,5.3,30a39.642,39.642,0,0,1,6.575-2.3A25.8,25.8,0,0,1,17.9,27a25.482,25.482,0,0,1,6,.7A39.98,39.98,0,0,1,30.45,30a5.628,5.628,0,0,1,2.525,2.125A5.708,5.708,0,0,1,33.9,35.3v3.2A1.454,1.454,0,0,1,32.4,40Zm32.4,0a1.248,1.248,0,0,0,.8-.525,1.82,1.82,0,0,0,.3-1.075V35.3a8.093,8.093,0,0,0-1.6-5.175,11.711,11.711,0,0,0-4.2-3.275,49.585,49.585,0,0,1,6.5,1.175A22.911,22.911,0,0,1,42.55,29.8a7.739,7.739,0,0,1,2.6,2.35,5.482,5.482,0,0,1,.95,3.15v3.2A1.454,1.454,0,0,1,44.6,40ZM17.9,23.95a7.193,7.193,0,0,1-7.5-7.5,7.193,7.193,0,0,1,7.5-7.5,7.193,7.193,0,0,1,7.5,7.5,7.193,7.193,0,0,1-7.5,7.5Zm18-7.5a7.193,7.193,0,0,1-7.5,7.5,11.181,11.181,0,0,1-1.225-.075A5.289,5.289,0,0,1,25.95,23.6a8.206,8.206,0,0,0,1.825-3.075A12.523,12.523,0,0,0,28.4,16.45a11.638,11.638,0,0,0-.625-3.975A10.63,10.63,0,0,0,25.95,9.3a10.552,10.552,0,0,1,1.225-.25,8.426,8.426,0,0,1,1.225-.1,7.193,7.193,0,0,1,7.5,7.5ZM4.9,37h26V35.3a2.859,2.859,0,0,0-.475-1.55A2.614,2.614,0,0,0,29.25,32.7a33.761,33.761,0,0,0-6.05-2.15A24.178,24.178,0,0,0,17.9,30a24.52,24.52,0,0,0-5.325.55A33.464,33.464,0,0,0,6.5,32.7a2.48,2.48,0,0,0-1.15,1.05A2.974,2.974,0,0,0,4.9,35.3Zm13-16.05a4.361,4.361,0,0,0,4.5-4.5,4.361,4.361,0,0,0-4.5-4.5,4.361,4.361,0,0,0-4.5,4.5,4.361,4.361,0,0,0,4.5,4.5ZM17.9,16.45ZM17.9,30Z",
    transform: "translate(-1.9 -8.95)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupGreen);
export default __webpack_public_path__ + "static/media/group_green.a787e325125393a46d8dad9078bd6947.svg";
export { ForwardRef as ReactComponent };